import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import MovieCard from '@/components/base/MovieCard';
import SEOMeta from '@/components/base/SEOMeta';
import SchemaOrg from '@/components/base/SchemaOrg';
import { categories, movies } from '@/mocks/movies';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const activeCategory = categories.find((c) => c.slug === slug) || categories[0];
  const filteredMovies = movies.filter((m) => m.category === activeCategory.slug);

  const categoryMeta: Record<string, { title: string; description: string; keywords: string }> = {
    movie: {
      title: '电影 - 屁屁影院 | 最新院线大片 经典电影 高清在线观看',
      description: '屁屁影院电影频道提供最新院线大片、经典电影、高分佳片在线观看。涵盖科幻、动作、喜剧、爱情、恐怖等多种类型的电影资源，HD高清画质，极速播放体验。',
      keywords: '在线电影,免费电影,高清电影,最新电影,经典电影,院线大片,电影在线观看',
    },
    tv: {
      title: '电视剧 - 屁屁影院 | 热门国产剧 韩剧 美剧 日剧在线观看',
      description: '屁屁影院电视剧频道提供热门国产剧、韩剧、美剧、日剧等高清电视剧在线观看。最新剧集每日更新，追剧首选平台，支持多线路切换。',
      keywords: '在线电视剧,免费电视剧,热门国产剧,韩剧在线,美剧在线,最新电视剧,追剧平台',
    },
    anime: {
      title: '动漫 - 屁屁影院 | 日本动漫 国产动漫 剧场版在线观看',
      description: '屁屁影院动漫频道提供日本动漫、国产动漫、剧场版等高清动漫资源在线观看。最新番剧同步更新，热血、治愈、搞笑、奇幻等多种类型，动漫迷的追番天堂。',
      keywords: '在线动漫,日本动漫,国产动漫,剧场版动漫,最新番剧,热血动漫,动漫在线观看',
    },
  };

  const meta = categoryMeta[activeCategory.slug] || categoryMeta.movie;

  return (
    <>
      <SEOMeta
        title={meta.title}
        description={meta.description}
        keywords={meta.keywords}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: meta.title,
          description: meta.description,
          url: `https://www.ppcinema.com/category/${activeCategory.slug}`,
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: '首页',
              item: 'https://www.ppcinema.com',
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: activeCategory.name,
            },
          ],
        }}
      />

      <ScrollToTop />
      <Navbar />

      <main className="pt-20">
        <div className="px-4 md:px-6 max-w-7xl mx-auto">
          <Breadcrumb
            items={[
              { label: '首页', to: '/' },
              { label: activeCategory.name },
            ]}
          />

          <div className="mb-6 md:mb-8">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-2">
              {activeCategory.name}
            </h1>
            <p className="text-sm text-foreground-500">{activeCategory.description}</p>
          </div>

          <div className="flex items-center gap-2 mb-8 bg-background-100 rounded-full p-1 w-fit">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeCategory.slug === cat.slug
                    ? 'bg-primary-500 text-white'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="flex items-center justify-between mb-6">
            <p className="text-sm text-foreground-500">
              共找到 <strong className="text-foreground-900">{filteredMovies.length}</strong> 部{activeCategory.name}
            </p>
            <select
              className="px-3 py-2 text-sm rounded-lg bg-background-100 border border-background-200/70 text-foreground-700 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer"
              defaultValue="latest"
            >
              <option value="latest">最新更新</option>
              <option value="rating">评分最高</option>
              <option value="year">年份最新</option>
            </select>
          </div>

          {filteredMovies.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5 pb-10" data-product-shop>
              {filteredMovies.map((movie) => (
                <MovieCard key={movie.id} {...movie} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500">暂无相关资源，请稍后再来</p>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </>
  );
}